var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceHeaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0_2909_76883)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2909_76883",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2909_76883",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2909_76883",
    width: 48,
    height: 48,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADA0lEQVR4nO2XTUzTYBjHHz6iFy8SEuPdAHo0HsVg3CCTDUSzlXZCCy0f6g3UhNHSxERlbyfhQOIBwyqGaESOrmx+JAaQmJiQ6M2bX8REb4ImZvKYlQFjdsTMCm/jfsmTLOuz5v97+7R9B1CgQIECdoJx5hsmGLSuwBLQCI5CGUbhBeqAaPhyhGcQY140e1K9o1AGtIA6NGEU4ubnBDObUyDOzKT7E6nfAC3gBJSjDh9Rh2OYCJDcAoHrGIUas3cCyoEmUIfjqMMnnKoazykwWTVu9kShBmgEx+EARkvG0GhM/hZ+ujGJt0vHUj1AOxhnOi2eQBI4CUwEetHw/TQrzvSAE0Ed5lGHl+BE8FFzPRpNSzh9ahnjjAecBiYC7zPm/x04idCZerQqgP9dAB96KtDwXUbDdxoRisBJAmg0VKLhWzY3W6mKecO2JU6Dz3bjnxTkAxq+0Hr4VYHFvE60gwJslsCcswRUtRhj3mGMeb+g4Z3HWMMh6gWCoaH9gkIu8gqZ5BXtjjAQZlRVLbU7uK0CqqoWC0qkjlfIFK+QH4KiYWbxMnndIg8eBDoFsIhXyFx2aAuJr20DEZY6AV6NVJkhZe27oGgGL5OrW8rI5KbYN7yPHgFF614NR+6ufWd5BRTtTW4pbXbnBGTtnhmin3RtJeD33y9plUmrIGsLgkKSm+XIzN8GxHwFBIUspkK0y+HKrQT+9Qpj/iNE5gSZPN4s5SCBbOq5c3t5ObziWAFXc/sR9tIVqxv1Oa+Qobb+yFGqBWo5kTnZdgFbQoM5HqVkpVWONFAr4ObEPjcnYd3ZLmzs7sVg37UHgqw95WXyOeNdcItiAWk0JWAWK34A2PgTs/FW1m7YHRBtuwc48cmagIsVRzKPZYxRD7UCblZ8uyZQF5SqLQUGwgyVAn6/f5eLk5Lp1V9M7VKtr0C4mkqBE4xUsT7/nDicfdzc7Cnk1Xl1ZA+VAm6uw7MxPp2HtzMg2iHg4qTu9PgsbPcKoy0jxHW4XKy4XMtKQUcKFChQABzBL4BOmTAoVtWwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceHeaderIcon);
export default __webpack_public_path__ + "static/media/performanceHeaderIcon.737b62c9e2d597fe342ed16c2704566f.svg";
export { ForwardRef as ReactComponent };